module.exports = __webpack_public_path__ + "static/media/CloseSelected.9e6a8783.svg";